document.addEventListener("DOMContentLoaded", function() {
    var btn = document.getElementById("open-size-guide");
    var popin = document.getElementById("size-guide-popin");
    var close = document.getElementById("close-size-guide");
    var main = document.querySelector("main");
    var body = document.body;
    var html = document.documentElement;

    if (btn && popin && close && main) {
    btn.addEventListener("click", function() {
        popin.classList.add("open");
        main.style.zIndex = "90";
        body.classList.add("overflow-hidden-mobile");
        html.classList.add("noscroll");
    });

    function closePopin() {
        popin.classList.remove("open");

        // Attendre la fin de la transition d'opacité de l'overlay
        const onTransitionEnd = (e) => {
        if (e.propertyName === "opacity") {
            main.style.zIndex = "";
            body.classList.remove("overflow-hidden-mobile");
            html.classList.remove("noscroll");
            popin.removeEventListener("transitionend", onTransitionEnd);
        }
        };
        popin.addEventListener("transitionend", onTransitionEnd);
    }

    close.addEventListener("click", closePopin);

    window.addEventListener("click", function(e) {
        if (e.target === popin) {
        closePopin();
        }
    });
    }
});